import React from "react";

const DataTrend = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M550,842c-0.474,6.588-4.111,13.6-7.5,18L524,842h26Z"
      transform="translate(-490 -810)"
      fill="#9f4c4c"
      fillRule="evenodd"
    />
    <path
      d="M538.432,863.732A30.047,30.047,0,0,1,490,839.92c0-15.7,11.48-28.536,28-29.92v32Z"
      transform="translate(-490 -810)"
      fill="#bf873e"
      fillRule="evenodd"
    />
    <path
      d="M522,810a30.058,30.058,0,0,1,28,28H522V810Z"
      transform="translate(-490 -810)"
      fill="#5b75a0"
      fillRule="evenodd"
    />
  </svg>
);

export default DataTrend;
